(() => {
  const params = new URLSearchParams(window.location.search);
  const key = params.get("categoria") || "bautizo";
  const productSlug = params.get("producto");
  const collection = window.lesAmisCollections?.[key] || window.lesAmisCollections?.bautizo;
  const searchPath = window.location.pathname || "/search";

  const collectionPage = document.querySelector("[data-static-collection-page]");
  const productPage = document.querySelector("[data-static-product-page]");

  const collectionUrl = (collectionKey) => `${searchPath}?categoria=${encodeURIComponent(collectionKey)}`;
  const productUrl = (collectionKey, slug) =>
    `${searchPath}?categoria=${encodeURIComponent(collectionKey)}&producto=${encodeURIComponent(slug)}`;

  const renderCollection = () => {
    if (!collection || !collectionPage) return;
    productPage?.setAttribute("hidden", "");
    collectionPage.removeAttribute("hidden");

    document.querySelector("[data-collection-eyebrow]").textContent = collection.eyebrow;
    document.querySelector("[data-collection-title]").textContent = collection.title;
    document.querySelector("[data-collection-text]").textContent = collection.text;
    document.title = `${collection.title} · Les Amis`;

    const productGrid = document.querySelector("[data-collection-products]");
    if (!productGrid) return;

    productGrid.innerHTML = collection.products
      .map(([name, category, description, sizes]) => {
        const slug = window.slugifyProduct(name);
        const options = sizes.map((size) => `<option>${size}</option>`).join("");

        return `
          <article class="product-card reveal is-visible" id="producto-${slug}" data-product="${name}" data-category="${category}" data-price="1">
            <a class="product-card-media" href="${productUrl(key, slug)}" aria-label="Ver producto ${name}">
              <div class="image-placeholder ratio-4-5"></div>
            </a>
            <div class="product-info">
              <span>${category}</span>
              <h3><a class="product-title-link" href="${productUrl(key, slug)}">${name}</a></h3>
              <p class="product-description">${description}</p>
              <div class="product-purchase">
                <div class="price-row"><strong>1 €</strong><small>IVA incluido</small></div>
                <label>Talla<select class="product-size" aria-label="Talla ${name}">${options}</select></label>
                <div class="product-actions">
                  <a class="button button-secondary" href="${productUrl(key, slug)}">Ver producto</a>
                  <button class="button button-primary add-to-cart" type="button">Añadir al carrito</button>
                </div>
              </div>
            </div>
          </article>
        `;
      })
      .join("");
  };

  const renderProduct = () => {
    const product = window.lesAmisProducts?.find((item) => item.collectionKey === key && item.slug === productSlug)
      || window.lesAmisProducts?.find((item) => item.slug === productSlug);

    if (!product || !productPage) {
      renderCollection();
      return;
    }

    collectionPage?.setAttribute("hidden", "");
    productPage.removeAttribute("hidden");

    const shell = document.querySelector("[data-product-shell]");
    shell.dataset.product = product.name;
    shell.dataset.category = product.category;
    shell.dataset.price = product.price;

    document.querySelector("[data-product-category]").textContent = product.category;
    document.querySelector("[data-product-title]").textContent = product.name;
    document.querySelector("[data-product-description]").textContent = product.description;
    document.querySelector("[data-back-to-collection]").href = collectionUrl(product.collectionKey);
    document.querySelector("[data-product-sizes]").innerHTML = product.sizes.map((size) => `<option>${size}</option>`).join("");
    document.title = `${product.name} · Les Amis`;

    const gallery = document.querySelector("[data-product-gallery]");
    gallery.innerHTML = [1, 2, 3, 4]
      .map(
        (number) => `
          <div class="product-photo-slide${number === 1 ? " is-active" : ""}" data-product-slide>
            <div class="product-photo-slot image-placeholder" role="img" aria-label="Foto ${number} de ${product.name}">
              <span>Foto ${number}</span>
            </div>
          </div>
        `,
      )
      .join("");

    gallery.insertAdjacentHTML(
      "beforeend",
      `
        <div class="product-gallery-arrows" aria-label="Cambiar foto">
          <button class="product-gallery-arrow" type="button" data-product-prev aria-label="Foto anterior">‹</button>
          <button class="product-gallery-arrow" type="button" data-product-next aria-label="Foto siguiente">›</button>
        </div>
      `,
    );

    const slides = [...document.querySelectorAll("[data-product-slide]")];
    let activeSlide = 0;
    const showSlide = (index) => {
      activeSlide = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle("is-active", slideIndex === activeSlide));
    };

    document.querySelector("[data-product-prev]")?.addEventListener("click", () => showSlide(activeSlide - 1));
    document.querySelector("[data-product-next]")?.addEventListener("click", () => showSlide(activeSlide + 1));
  };

  if (productSlug) {
    renderProduct();
  } else {
    renderCollection();
  }
})();
